(() => {
  function initialize(root) {
    if (root.dataset.folderReady) return;
    const pages = [...root.querySelectorAll('.ivonne-folder-page')];
    if (!pages.length) return;
    root.dataset.folderReady = 'true';
    let current = 0;
    const prev = root.querySelector('[data-folder-prev]');
    const next = root.querySelector('[data-folder-next]');
    const zoom = root.querySelector('[data-folder-zoom]');
    const viewport = root.querySelector('.ivonne-folder-viewport');
    const counter = root.querySelector('.ivonne-folder-counter');
    prev.hidden = next.hidden = false;
    zoom.closest('label').hidden = false;
    function update() {
      pages.forEach((page, i) => { page.hidden = i !== current; });
      prev.disabled = current === 0;
      next.disabled = current === pages.length - 1;
      counter.textContent = (root.dataset.counter || 'Pagina {current} van {total}').replace('{current}', current + 1).replace('{total}', pages.length);
      const ratio = Number(zoom.value);
      pages.forEach(page => {
        page.style.width = `${ratio * 100}%`;
        page.style.maxWidth = `${794 * ratio}px`;
      });
    }
    prev.addEventListener('click', () => { if (current > 0) { current--; update(); viewport.scrollTo(0, 0); } });
    next.addEventListener('click', () => { if (current < pages.length - 1) { current++; update(); viewport.scrollTo(0, 0); } });
    zoom.addEventListener('change', update);
    update();
  }
  document.querySelectorAll('[data-ivonne-folder]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-ivonne-folder]').forEach(initialize);
  });
})();
